import { AnyT, jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { CollectionSortRequest } from './collection-sort.request';
import { CollectionFilterRequest } from './collection-filter.request';

@jsonObject
export class CollectionRequest {
  @jsonMember(Number)
  public readonly page!: number;

  @jsonMember(Number)
  public readonly pageSize!: number;

  @jsonMember(Boolean)
  public readonly all!: boolean;

  @jsonMember(AnyT)
  public readonly filter?: CollectionFilterRequest[];

  @jsonArrayMember(CollectionSortRequest)
  public readonly sort?: CollectionSortRequest[];

  @jsonMember(String)
  public readonly query?: string;

  public constructor(
    page: number,
    pageSize: number,
    all: boolean,
    filters?: CollectionFilterRequest[],
    sorts?: CollectionSortRequest[],
    query?: string,
  ) {
    this.page = page;
    this.pageSize = pageSize;
    this.all = all;
    this.filter = filters;
    this.sort = sorts;
    this.query = query;
  }
}
